export default __webpack_public_path__ + "static/media/barrier.1db42100.png";